<div>
	<div class="ibox-title">
		<h5>Today's Stats for {{ Title }}</h5>
	</div>

	<div class="ibox-content">
		<!--Options-->
		<div class="ButtonGrid">
			<button
				[ngClass]="{
					btn: true,
					'btn-primary': OptionID != 0,
					'btn-warning': OptionID == 0
				}"
				(click)="SelectOption(0)"
			>
				Facility
			</button>

			<button
				[ngClass]="{
					btn: true,
					'btn-primary': OptionID != 1,
					'btn-warning': OptionID == 1
				}"
				(click)="SelectOption(1)"
			>
				District
			</button>
		</div>

		<!--Loading Overlay-->
		<div class="CenterDiv" *ngIf="loading == true">
			<p-progressSpinner></p-progressSpinner>
		</div>

		<!--Stats-->
		<div class="StatGrid" *ngIf="loading == false">
			<label>Visitors Signed In:</label>
			<p>{{ SignedInCount }}</p>

			<label>Visitors Signed Out:</label>
			<p>{{ SignedOutCount }}</p>

			<label>Visitors Signed Out by System:</label>
			<p>{{ SystemSignedOutCount }}</p>

			<label>Visitors In Building:</label>
			<p>{{ InBuildingCount }}</p>

			<label>Visitor Denied Entry:</label>
			<p>{{ DeniedCount }}</p>

			<label>Student Scans (From App)</label>
			<p>{{ StudentScans }}</p>

			<label>Staff Scans (From App)</label>
			<p>{{ StaffScans }}</p>

			<label>Potential Offender Matches (for District)</label>
			<p>{{ DistrictPotentialOffenderHits }}</p>
		</div>
	</div>
</div>
